module.exports = __webpack_public_path__ + "img/img_digitalthread_desp.0213a156.png";